export const items = [
    {
        title: "Getting started",
        items: [
            {
                title: "How to supply assets to earn interest?",
                content:
                    "Coming Soon...",
            },
            {
                title: "How to borrow assets to leverage your position?",
                content:
                    "Coming Soon...",
            },
            {
                title: "How to withdraw assets to your wallet?",
                content:
                    "Coming Soon...",
            },
            {
                title: "How to repay assets to unlock your collateral?",
                content:
                    "Coming Soon...",
            },
        ],
    },
    {
        title: "Collateral & Private Supply",
        items: [
            {
                title: "How to add collateral to my position?",
                content:
                    "Coming Soon...",
            },
            {
                title: "What is private supply?",
                content:
                    "Coming Soon...",
            },
            {
                title: "How to add collateral as private supply",
                content:
                    "Coming Soon...",
            },
            {
                title: "How to withdraw private supply?",
                content:
                    "Coming Soon...",
            },
        ],
    },
    {
        title: "Borrowing Power",
        items: [
            {
                title: "How to borrow assets?",
                content:
                    "Coming Soon...",
            },
            {
                title: "How much can I borrow?",
                content:
                    "Coming Soon...",
            },
            {
                title: "When do I need to repay?",
                content:
                    "Coming Soon...",
            },
            {
                title: "What is my safe limit?",
                content:
                    "Coming Soon...",
            },
            {
                title: "What happens if I borrow too much?",
                content:
                    "Coming Soon...",
            },
        ],
    },
    {
        title: "Liquidations",
        items: [
            {
                title: "How can I get liquidated",
                content:
                    "Coming Soon...",
            },
            {
                title: "How to prevent liquidation?",
                content:
                    "Coming Soon...",
            },
            {
                title: "Will my position be liquidated completely?",
                content:
                    "Coming Soon...",
            },
            {
                title: "Who can liquidate my position?s",
                content:
                    "Coming Soon...",
            },
        ],
    },
    {
        title: "Wise Power Farms",
        items: [
            {
                title: "What is the purpose of Wise Power Farms?",
                content:
                    "Coming Soon...",
            },
            {
                title: "How safe are these Power Farms?",
                content:
                    "Coming Soon...",
            },
            {
                title: "How to open Power Farm position?",
                content:
                    "Coming Soon...",
            },
            {
                title: "When can I close my Power Farm position?",
                content:
                    "Coming Soon...",
            },
            {
                title: "Can my power farm position be liquidated?",
                content:
                    "Coming Soon...",
            },
        ],
    },
];
